import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const FinancialGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',

        sortable: true,
        width: 60,
    },
    {    field: 'fileId',
        headerName: 'File ID',
        sortable: true,
        width: 180,
    },
    {
        field: 'propertyId',
        headerName: 'Property ID',
        sortable: true,
        width: 100,
    },
    {
        field: 'productName',
        headerName: 'Product Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 300,
    },
    {
        field: 'episodeName',
        headerName: 'Episode Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'seriesExternalId',
        headerName: 'Series ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 80,

    },
    {
        field: 'seriesName',
        headerName: 'Series Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 250,

    },

    {
        field: 'seasonExternalId',
        headerName: 'Season ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 80,
    },
    {
        field: 'season',
        headerName: '#',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 40,
    },
    {
        field: 'seasonName',
        headerName: 'Season Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 250,
    },

    {
        field: 'displayAmount',
        headerName: 'Amount',
        sortable: true,
        width: 150,
    },
    {
        field: 'amountType',
        headerName: 'Amount Type',

        sortable: true,
        width: 100,
    },
    {
        field: 'units',
        headerName: 'Units',
        sortable: true,
        width: 150,
    },
    {
        field: 'periodEndDate',
        headerName: 'Period End',
        sortable: true,
        width: 150,
    },
    {
        field: 'account',
        headerName: 'Account',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'financialMarket',
        headerName: 'Financial Market',
        sortable: true,
        width: 150,
    },
    {
        field: 'territory',
        headerName: 'Territory',
        sortable: true,
        width: 150,
    },
    {
        field: 'languageCode',
        headerName: 'Language',
        sortable: true,
        width: 100,
    },

    {
        field: 'licenseId',
        headerName: 'License ID',
        sortable: true,
        width: 150,
    },
    {
        field: 'licensee',
        headerName: 'Licensee',
        sortable: true,
        width: 150,
    },
    {
        field: 'licenseAmount',
        headerName: 'License Amt',
        sortable: true,
        hide: true,
        width: 150,
    },
    {
        field: 'licenseDisplayAmount',
        headerName: 'License Amount',
        sortable: true,
        width: 150,
    },
    {
        field: 'availBegin',
        headerName: 'Avail Begin',
        sortable: true,
        width: 150,
    },
    {
        field: 'availEnd',
        headerName: 'Avail End',
        sortable: true,
        width: 150,
    },
    {
        field: 'executionDate',
        headerName: 'Execution Date',
        sortable: true,
        width: 150,
    },
    {
        field: 'adjustFrom',
        headerName: 'Adjust From',
        sortable: true,
        width: 150,
    },
    {
        field: 'adjustTo',
        headerName: 'Adjust To',
        sortable: true,
        width: 150,
    },
    {
        field: 'adjustNote',
        headerName: 'Adjust Note',
        sortable: true,
        width: 150,
    },
    {
        field: 'sourceSystem',
        headerName: 'Source System',

        sortable: true,
        width: 150,
    },
    {
        field: 'sourceSystemId',
        headerName: 'Source System ID',

        sortable: true,
        width: 180,
    },
    {
        field: 'stakeholderId',
        headerName: 'Stakeholder ID',

        sortable: true,
        width: 120,
    },
    {
        field: 'contractId',
        headerName: 'Contract ID',

        sortable: true,
        width: 100,
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },

];
